import moment from 'moment';
import { productFamilyCodes } from 'types/productFamilyCodes';
import { LOYALTY_TIER_3, LOYALTY_TIER_4, LOYALTY_TIER_5, LOYALTY_PROMO_PERIODS } from 'constants/clubEurostar';
import { LOYALTY_NUMBER_PREFIX } from 'constants/passengers';

export const sendDiscountCardData = (loyaltyNumber, passengerId, passengersBooking, subscriptionCode, subscriptionID) => {
  const discountCards = [];

  if (subscriptionID) {
    discountCards.push({
      code: subscriptionCode.startsWith('TH_FP') ? productFamilyCodes.THPASSFP : productFamilyCodes.THPASSPR,
      identifier: `${subscriptionID}`,
      requiresPassengerIdentifier: false
    });
  }

  const passengerBeingChanged = passengersBooking?.find((pax) => pax.id === passengerId);

  const loyaltyDataOfPassengerBeingChanged = Boolean(
    passengerBeingChanged?.discountCards?.find((discount) => discount.code === productFamilyCodes.EUROSTAR_LOYALTY)
  );

  if (loyaltyNumber || loyaltyDataOfPassengerBeingChanged) {
    discountCards.push({
      code: productFamilyCodes.EUROSTAR_LOYALTY,
      identifier: loyaltyNumber ?? '',
      name: 'Club Eurostar Membership Number',
      requiresPassengerIdentifier: true
    });
  }

  return discountCards;
};

export const getLoyaltyData = (loyaltyNumber, paxId, passengersBooking, subscriptionCode, subscriptionID) => {
  let filteredLoyaltyNumber;

  if (loyaltyNumber) {
    filteredLoyaltyNumber = `${loyaltyNumber}`.startsWith(`${LOYALTY_NUMBER_PREFIX}`)
      ? loyaltyNumber
      : `${LOYALTY_NUMBER_PREFIX}${loyaltyNumber}`;
  } else {
    filteredLoyaltyNumber = '';
  }

  return sendDiscountCardData(filteredLoyaltyNumber, paxId, passengersBooking, subscriptionCode, subscriptionID);
};

export const getLoyaltyPromoPeriod = ({ isLoyalty, confirmedTimestamp = '' }) => {
  if (isLoyalty) {
    return (
      LOYALTY_PROMO_PERIODS.find(({ start, end }) =>
        moment(confirmedTimestamp ? confirmedTimestamp : undefined).isBetween(start, end, 'day', '[]')
      ) ?? null
    );
  }

  return null;
};

export const isLoyaltyTier3OrAbove = (tierCode) => [LOYALTY_TIER_3, LOYALTY_TIER_4, LOYALTY_TIER_5].includes(tierCode);
